export const NETWORK_SEARCH_LANGUAGES = [
	{
		id: 'en',
		language: 'English',
		alias: 'English',
		text: 'ATTENTION: If you speak English, language assistance services, free of charge, are available to you. Call 1-800-678-9133 (TTY: 711). American Specialty Health complies with applicable Federal civil rights laws and does not discriminate on the basis of race, color, national origin, age, disability, or sex.',
	},
	{
		id: 'es',
		language: 'Español',
		alias: 'Spanish',
		text: 'ATENCIÓN: si habla español, tiene a su disposición servicios gratuitos de asistencia lingüística. Llame al 1-800-678-9133 (TTY: 711). American Specialty Health cumple con las leyes federales de derechos civiles aplicables y no discrimina por motivos de raza, color, nacionalidad, edad, discapacidad o sexo.',
	},
	{
		id: 'zh',
		language: '繁體中文',
		alias: 'Traditional Chinese',
		text: '注意：如果您使用繁體中文，您可以免費獲得語言援助服務。請致電 1-800-678-9133（TTY：711）。 American Specialty Health 遵守適用的聯邦民權法律規定，不因種族、膚色、民族血統、年齡、殘障或性別而歧視任何人。',
	},
	{
		id: 'vi',
		language: 'Tiếng Việt',
		alias: 'Vietnamese',
		text: 'CHÚ Ý: Nếu bạn nói Tiếng Việt, có các dịch vụ hỗ trợ ngôn ngữ miễn phí dành cho bạn. Gọi số 1-800-678-9133 (TTY: 711). American Specialty Health tuân thủ luật dân quyền hiện hành của Liên bang và không phân biệt đối xử dựa trên chủng tộc, màu da, nguồn gốc quốc gia, độ tuổi, khuyết tật, hoặc giới tính.',
	},
	{
		id: 'ko',
		language: '한국어',
		alias: 'Korean',
		text: '주의: 한국어를 사용하시는 경우, 언어 지원 서비스를 무료로 이용하실 수 있습니다. 1-800-678-9133 (TTY: 711)번으로 전화해 주십시오. American Specialty Health 은(는) 관련 연방 공민권법을 준수하며 인종, 피부색, 출신 국가, 연령, 장애 또는 성별을 이유로 차별하지 않습니다.',
	},
	{
		id: 'tl',
		language: 'Tagalog',
		alias: 'Tagalog',
		text: 'PAUNAWA: Kung nagsasalita ka ng Tagalog, maaari kang gumamit ng mga serbisyo ng tulong sa wika nang walang bayad. Tumawag sa 1-800-678-9133 (TTY: 711). Sumusunod ang American Specialty Health sa mga naaangkop na Pederal na batas sa karapatang sibil at hindi nandidiskrimina batay sa lahi, kulay, bansang pinagmulan, edad, kapansanan o kasarian.',
	},
	{
		id: 'ar',
		language: 'العربية ',
		alias: 'Arabic',
		text: 'ملحوظة: إذا كنت تتحدث اذكر اللغة، فإن خدمات المساعدة اللغوية تتوافر لك بالمجان. اتصل برقم PH: 1-800-678-9133 (رقم هاتف الصم والبكم: TTY: 711). يلتزم American Specialty Health بقوانين الحقوق المدنية الفدرالية المعمول بها ولا يميز على أساس العرق أو اللون أو الأصل الوطني أو السن أو الإعاقة أو الجنس.',
	},
	{
		id: 'ht',
		language: 'Kreyòl Ayisyen',
		alias: 'Haitian Creole',
		text: 'ATANSYON: Si w pale Kreyòl Ayisyen, gen sèvis èd pou lang ki disponib gratis pou ou. Rele 1-800-678-9133 (TTY: 711). American Specialty Health konfòm ak lwa sou dwa sivil Federal ki aplikab yo e li pa fè diskriminasyon sou baz ras, koulè, peyi orijin, laj, enfimite oswa sèks.',
	},
	{
		id: 'fr',
		language: 'Français',
		alias: 'French',
		text: `ATTENTION : Si vous parlez français, des services d'aide linguistique vous sont proposés gratuitement. Appelez le 1-800-678-9133 (ATS : 711). American Specialty Health respecte les lois fédérales en vigueur relatives aux droits civiques et ne pratique aucune discrimination basée sur la race, la couleur de peau, l'origine nationale, l'âge, le sexe ou un handicap.`,
	},
	{
		id: 'pl',
		language: 'Polski',
		alias: 'Polish',
		text: `UWAGA: Jeżeli mówisz po polsku, możesz skorzystać z bezpłatnej pomocy językowej. Zadzwoń pod numer 1-800-678-9133 (TTY: 711). American Specialty Health postępuje zgodnie z obowiązującymi federalnymi prawami obywatelskimi i nie dopuszcza się dyskryminacji ze względu na rasę, kolor skóry, pochodzenie, wiek, niepełnosprawność bądź płeć.`,
	},
	{
		id: 'pt',
		language: 'Português',
		alias: 'Portuguese',
		text: `ATENÇÃO: Se fala português, encontram-se disponíveis serviços linguísticos, grátis. Ligue para 1-800-678-9133 (TTY: 711). American Specialty Health cumpre as leis de direitos civis federais aplicáveis e não exerce discriminação com base na raça, cor, nacionalidade, idade, deficiência ou sexo.`,
	},
	{
		id: 'it',
		language: 'Italiano',
		alias: 'Italian',
		text: `ATTENZIONE: In caso la lingua parlata sia l'italiano, sono disponibili servizi di assistenza linguistica gratuiti. Chiamare il numero 1-800-678-9133 (TTY: 711). American Specialty Health è conforme a tutte le leggi federali vigenti in materia di diritti civili e non pone in essere discriminazioni sulla base di razza, colore, origine nazionale, età, disabilità o sesso.`,
	},
	{
		id: 'ja',
		language: '日本語',
		alias: 'Japanese',
		text: `注意事項：日本語を話される場合、無料の言語支援をご利用いただけます。1-800-678-9133（TTY:711 まで、お電話にてご連絡ください。 American Specialty Healthは適用される連邦公民権法を遵守し、人種、肌の色 出身国、年齢、障害または性別に基づく差別をいたしません。`,
	},
	{
		id: 'de',
		language: 'Deutsch',
		alias: 'German',
		text: `ACHTUNG: Wenn Sie Deutsch sprechen, stehen Ihnen kostenlos sprachliche Hilfsdienstleistungen zur Verfügung. Rufnummer: 1-800-678-9133 (TTY: 711). American Specialty Health erfüllt geltenden bundesstaatliche Menschenrechtsgesetze und lehnt jegliche Diskriminierung aufgrund von Rasse, Hautfarbe, Herkunft, Alter, Behinderung oder Geschlecht ab.`,
	},
	{
		id: 'fa',
		language: 'فارسی',
		alias: 'Farsi',
		text: `توجه: اگر به زبان فارسی گفتگو می کنید، تسهیلات زبانی بصورت رایگان برای شما فراهم می باشد. با PH: 1-800-678-9133 (TTY: 711) تماس بگیرید. American Specialty Health از قوانین حقوق مدنی فدرال مربوطه تبعیت می کند و هیچگونه تبعیضی بر اساس نژاد، رنگ پوست، اصلیت ملیتی، سن، ناتوانی یا جنسیت افراد قایل نمی شود.`,
	},
	{
		id: 'hi',
		language: 'हिंदी',
		alias: 'Hindi',
		text: `ध्यान दें: यदि आप हिंदी बोलते हैं तो आपके लिए मुफ्त में भाषा सहायता सेवाएं उपलब्ध हैं। 1-800-678-9133 (TTY: 711) पर कॉल करें। American Specialty Health लागू होने योग्य संघीय नागरिक अधिकार क़ानून का पालन करता है और जाति, रंग, राष्ट्रीय मूल, आयु, विकलांगता, या लिंग के आधार पर भेदभाव नहीं करता है।`,
	},
	{
		id: 'ium',
		language: 'Mien',
		alias: 'Mien',
		text: `QUAN TRỌNG: Nếu bạn gặp vấn đề với việc đọc tài liệu này và có nhu cầu ngôn ngữ khác không phải tiếng Anh, chúng tôi có nhân viên sẵn sàng giúp bạn. Bạn cũng có thể nhận lá thư này dạng giấy với ngôn ngữ ưu tiên của bạn. Bạn có thể gọi 1-800-678-913`,
	},
	{
		id: 'lo',
		language: 'Laotian',
		alias: 'Lao',
		text: 'ສິ່ງສຳຄັນ: ຖ້າຫາກທ່ານມີບັນຫາໃນການອ່ານເອກະສານນີ້ ແລະ ຕ້ອງການພາສາອື່ນທີ່ນອກເໜືອຈາກພາກສາອັງກິດ, ພວກເຮົາສາມາດຊອກຫາຄົນຊ່ວຍທ່ານໄດ້. ທ່ານຍັງອາດຈະສາມາດໄດ້ຮັບຈົດໝາຍນີ້ ທີ່ຂຽນເປັນພາສາທີ່ທ່ານຕ້ອງການ. ທ່ານສາມາດໂທຫາ 1-800-678-9133 (TTY/TDD-711) ໃນວັນຈັນ ຫາ ວັນສຸກ ເວລາ 5 ໂມງເຊົ້າ ຫາ 6 ໂມງແລງ ເວລາປາຊິຟິກ. ບໍ່ມີຄ່າບໍລິການສຳລັບການບໍລິການນີ້. ເພາະເອກະສານນີ້ອາດຕ້ອງການດຳເນີນການໂດຍທ່ານ, ຢາກໃຫ້ທ່ານຕິດຕໍ່ໃຫ້ໄວທີ່ສຸດເທົ່າທີ່ຈະເປັນໄປໄດ້。',
	},
	{
		id: 'uk',
		language: 'Ukranian',
		alias: 'Ukrainian',
		text: 'ВАЖЛИВО: Якщо у вас є проблеми з читанням цього документу та мовні потреби, окрім англійської мови, ви можете звернутися за допомогою. Ви також можете отримати цього листа переважною мовою. Ви можете зателефонувати за номером 1-800-678-9133 (TTY/TDD-711) з понеділка по п’ятницю з 5 години ранку до 6 години вечора за тихоокеанським часом. Послуга надається безкоштовно. Через те що, цей документ може потребувати від вас певних дій, зателефонуйте нам якомога швидше.',
	},
];
